import "./App.css";
import "./i18n";
import { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./styles/GlobalStyles.css";

import ScrollToTop from "./components/ScrollToTop";

import Hero from "./pages/Hero";
import Imcorp from "./pages/Imcorp";
import Abb from "./pages/Abb";
import Adme from "./pages/Adme";
import Ute from "./pages/Ute";
import Quote from "./pages/Quote";
import Success from "./pages/Success";
import About from "./pages/About";
import Portfolio from "./pages/Porfolio";
import NeuroSharp from "./pages/NeuroSharp";
import Upwork from "./pages/Upwork";
import Services from "./pages/Services";
import Roadmap from "./pages/Roadmap";
import FAQs from "./pages/FAQs";

import Brochure from "./pages/Brochure";

import "leaflet/dist/leaflet.css";

import useVisitTracking from "./hooks/useVisitTracking";

const Dashboard =
  process.env.NODE_ENV === "development"
    ? lazy(() => import("./pages/Dashboard"))
    : null;

// Forces a real server request for any path the React app doesn't own,
// so Cloudflare Pages can serve the correct file (e.g. /cloud-clipboard/reset-password/).
// Trailing slash ensures Cloudflare serves the directory index, not the catch-all.
function ExternalRedirect() {
  const { pathname, search, hash } = useLocation();
  const slash = pathname.endsWith("/") ? "" : "/";
  window.location.replace(pathname + slash + search + hash);
  return null;
}

function App() {
  useVisitTracking();
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Hero />} />
          <Route path="/portfolio/imcorp" element={<Imcorp />} />
          <Route path="/portfolio/abb" element={<Abb />} />
          <Route path="/portfolio/adme" element={<Adme />} />
          <Route path="/portfolio/ute" element={<Ute />} />
          <Route path="/portfolio/upwork" element={<Upwork />} />
          <Route path="/portfolio/neurosharp" element={<NeuroSharp />} />
          <Route path="/quote" element={<Quote />} />
          <Route path="/success" element={<Success />} />
          {Dashboard ? (
            <Route
              path="/dashboard"
              element={
                <Suspense fallback={null}>
                  <Dashboard />
                </Suspense>
              }
            />
          ) : null}
          <Route path="/about" element={<About />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/brochure" element={<Brochure />} />
          <Route path="/services" element={<Services />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="*" element={<ExternalRedirect />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
